var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tour-popup" }, [
    _c(
      "div",
      {
        staticClass: "modal welcome-modal",
        class: { displayBlock: _vm.displaySide },
        attrs: {
          id: "modal_welcome",
          "data-backdrop": "static",
          role: "dialog",
        },
      },
      [
        _c("div", { staticClass: "modal-dialog modal-md" }, [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("img", {
                staticClass: "close-btn",
                attrs: {
                  src: "/static/images/icons/popup_close.svg",
                  alt: "close-icon",
                  "data-dismiss": "modal",
                },
                on: {
                  click: function ($event) {
                    return _vm.stopTour()
                  },
                },
              }),
              _c("img", {
                staticClass: "img-responsive logo-rams",
                attrs: {
                  src: "/static/images/logos/RAMS_logo.png",
                  alt: "rams-logo",
                },
              }),
              _c("img", {
                staticClass: "header-swoop",
                attrs: {
                  src: "https://ramsdevstorage.blob.core.windows.net/customererrorpage/Header_swoop.png",
                  alt: "header-img",
                },
              }),
            ]),
            _c("div", { staticClass: "modal-body" }, [
              _c("p", { staticClass: "body-txt" }, [
                _vm._v("Welcome " + _vm._s(_vm.userName) + "!"),
              ]),
              _c("p", { staticClass: "body-txt sub-text" }, [
                _vm._v(
                  " Learn about the features available within RAMS with a walk-through tutorial. "
                ),
              ]),
            ]),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "div",
                [
                  _c("router-link", { attrs: { to: "/layout/dashboard" } }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn start-btn emergo-green-button",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            _vm.startTour()
                            _vm.emitEvent()
                          },
                        },
                      },
                      [_vm._v(" Start Tour ")]
                    ),
                  ]),
                ],
                1
              ),
              _c("div", [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-link skip-link",
                    attrs: { type: "button", "data-dismiss": "modal" },
                    on: {
                      click: function ($event) {
                        return _vm.stopTour()
                      },
                    },
                  },
                  [_vm._v(" Skip Tour ")]
                ),
              ]),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }